import { createRoute } from '@tanstack/react-router';
import { Route as parentRoute } from '../devices';
import KioskDeviceAddPage from '@/features/kiosk/pages/KioskDeviceAddPage';

export const Route = createRoute({
  getParentRoute: () => parentRoute,
  path: '/add',
  component: KioskDeviceAddPage,
});
